import { useNavigate } from "react-router-dom"
import routes from "routes"

import { SpnyTourEnum, useSuraasaPlusNewYear } from "../Context"
import ResumeTourBox from "../ResumeTourBox"
import { useTourContext } from "../TourProvider"

const ResumeImpactCourseTour = () => {
  const { setStep, setStepIndex, step } = useTourContext()
  const { spnyImpactCourseTour } = useSuraasaPlusNewYear()
  const navigate = useNavigate()

  if (spnyImpactCourseTour === SpnyTourEnum.initiated && !step) {
    return (
      <ResumeTourBox
        title="Explore the Learning Tab"
        subTitle="Get a quick walkthrough of where to find your lessons, assessments, and course resources."
        onContinue={() => {
          setStepIndex(0)
          navigate(routes.learning)
          setStep("joyride")
        }}
      />
    )
  }
  return null
}

export default ResumeImpactCourseTour
